import { TableRow, TextRow, AreaRow } from "./types";

// Regex para validar coordenadas geográficas
export const latRegex = /^-?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
export const longRegex = /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|[1-9]?\d(\.\d+)?)$/;

export interface ValidNamesLookup {
  hosts: Set<string>;
  pops: Set<string>;
  maps: Set<string>;
  icons: Set<string>;
}

function elementExists(
  row: TableRow,
  validNames: ValidNamesLookup,
): boolean {
  if (!row.selectedName || !row.type) return true;
  if (row.type === "Host") return validNames.hosts.has(row.selectedName);
  if (row.type === "POP") return validNames.pops.has(row.selectedName);
  if (row.type === "Mapa") return validNames.maps.has(row.selectedName);
  return true;
}

// Valida uma linha da tabela e retorna um mapa de erros por campo.
export function validateRow(
  row: TableRow,
  validNames?: ValidNamesLookup,
): Record<string, string> {
  const errors: Record<string, string> = {};

  // Tipo é obrigatório
  if (!row.type) errors.type = "Obrigatório";

  // Elemento: mensagem personalizada por tipo
  if (!row.selectedName) {
    if (row.type === "Host") errors.selectedName = "Selecione um host";
    else if (row.type === "POP") errors.selectedName = "Selecione um POP";
    else errors.selectedName = "Selecione um Mapa";
  } else if (validNames && !elementExists(row, validNames)) {
    if (row.type === "Host") errors.selectedName = "Host não encontrado";
    else if (row.type === "POP") errors.selectedName = "POP não encontrado";
    else errors.selectedName = "Mapa não encontrado";
  }

  // Latitude: obrigatória e deve estar no intervalo válido
  const latStr = String(row.lat ?? "").trim();
  if (latStr === "") errors.lat = "Obrigatório";
  else if (!latRegex.test(latStr)) errors.lat = "Latitude inválida (-90 a 90)";

  // Longitude: obrigatória e deve estar no intervalo válido
  const longStr = String(row.long ?? "").trim();
  if (longStr === "") errors.long = "Obrigatório";
  else if (!longRegex.test(longStr))
    errors.long = "Longitude inválida (-180 a 180)";

  // Ícone é obrigatório e deve existir na lista de ícones conhecidos
  if (!row.iconId) errors.iconId = "Obrigatório";
  else if (validNames && !validNames.icons.has(String(row.iconId)))
    errors.iconId = "Ícone não encontrado";

  return errors;
}

// Valida uma linha da tabela de Texto (tipo 3): apenas lat/long são
// obrigatórias. Conteúdo e cores são opcionais; título não é editado.
export function validateTextRow(row: TextRow): Record<string, string> {
  const errors: Record<string, string> = {};

  const latStr = String(row.lat ?? "").trim();
  if (latStr === "") errors.lat = "Obrigatório";
  else if (!latRegex.test(latStr)) errors.lat = "Latitude inválida (-90 a 90)";

  const longStr = String(row.long ?? "").trim();
  if (longStr === "") errors.long = "Obrigatório";
  else if (!longRegex.test(longStr))
    errors.long = "Longitude inválida (-180 a 180)";

  return errors;
}

// Valida uma linha da tabela de Área (tipo 4): apenas o título é obrigatório.
export function validateAreaRow(row: AreaRow): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!String(row.titulo ?? "").trim()) errors.titulo = "Obrigatório";
  return errors;
}
